
<section>
    <app-race-share-error-handling [error_header]="'RSP_ERROR_HEADING'" [error_sub_heading_1]="'CP_SM_USER_NOT_FOUND'"></app-race-share-error-handling>
</section>
